import { ChatModal } from "@/modules/ai/features/ask-ai-assistant/ui/chat-modal";
import { AiAssistantChat } from "@/modules/ai/features/ask-ai-assistant/ui/ai-assistant-chat";
import { useAiAssistantChat } from "@/modules/ai/features/ask-ai-assistant/model/use-ai-assistant-chat";

/**
 * Разговор живёт здесь, а не в карточке: бэкенд дописывает обмен в чат только когда ответ дошёл до
 * конца, поэтому свёрнутое окно не должно обрывать подписку.
 */
export function AskAiAssistant() {
  const chat = useAiAssistantChat();

  return (
    <ChatModal>
      {({ close }) => <AiAssistantChat {...chat} close={close} />}
    </ChatModal>
  );
}
